const aaa = [
	{
		path: "guahaoAdd",
		component: () => import("@/views/shezhi/guahaoAdd.vue"),
		meta:{title:'挂号'},
	},
]
export default aaa;